<template>
    <div id="kce-navigation" :class="{ menuOpen: isOpen }">
        <div class="kce-container">
            <nav class="kce-site-header__menu-wrapper">
                <div class="kce-site-header__menu-group">
                    <div class="kce-navigation__header">Stay Connected</div>
                    <ul class="kce-navigation">
                        <li class="kce-navigation__item"><a href="/keno-certified-expert/facebook-group">Facebook Group</a></li>
                        <li class="kce-navigation__item"><a href="/keno-certified-expert/latest-promotions">Latest Promotions</a></li>
                        <li class="kce-navigation__item"><a href="/keno-certified-expert/calendar">KENO Calendar</a></li>
                    </ul>
                </div>
                <div class="kce-site-header__menu-group">
                    <div class="kce-navigation__header">Why KENO</div>
                    <ul class="kce-navigation">
                        <li class="kce-navigation__item"><a href="/keno-certified-expert/tips">Tips for Selling</a></li>
                        <li class="kce-navigation__item"><a href="/keno-certified-expert/statistics">Stats/Facts</a></li>
                        <li class="kce-navigation__item"><a href="/keno-certified-expert/retailer-spotlight">Retailer Highlights/Success Stories</a></li>
                    </ul>
                </div>
                <div class="">
                    <div class="kce-navigation__header">KENO How-To</div>
                    <ul class="kce-navigation">
                        <li class="kce-navigation__item"><a href="/keno-certified-expert/rules">Game Rules</a></li>
                        <li class="kce-navigation__item"><a href="/keno-certified-expert/faq">FAQs</a></li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</template>
<script>
  export default {
    props: ['isOpen'],
    created() {
        console.log("Created! Is menu open? " + this.isOpen);
    },
    updated() {
        console.log("Updated! Is menu open? " + this.isOpen);
    }
  }
</script>